import { AccessDeniedPage } from "@climatepartner/components/ErrorPages";
import { ReactElement, useContext } from "react";

import { UserContext } from "../user-context";
import { isEmployeeInternal } from "../user-utils";
import { CFC_ROLE } from "./admin-roles-authorisation.guard.helpers";

type RolesGuardProps = {
  children: ReactElement | ReactElement[];
  allowedRoles: CFC_ROLE[];
};

export const AdminRolesAuthorisationGuard = ({ allowedRoles, children }: RolesGuardProps): ReactElement => {
  const { user, hasPermission } = useContext(UserContext);

  const isAllowedToAccess = allowedRoles.some((allowedRole) => {
    if (user && !user.isAuthenticated) {
      return false;
    }

    switch (allowedRole) {
      case CFC_ROLE.ADMIN: {
        return isEmployeeInternal(hasPermission);
      }
      case CFC_ROLE.EMISSION_FACTOR_ADMIN: {
        return user?.isEmissionFactorAdmin;
      }
      default: {
        return true;
      }
    }
  });

  return <>{isAllowedToAccess ? children : <AccessDeniedPage />}</>;
};
